import type React from 'react';

const ArrowLeft = () => (
  <path d="M653.656 83.718l-378.646 380.695c-25.393 25.53-25.489 69.547 0 95.174l378.646 380.695c26.138 26.28 68.5 26.303 94.661 0s26.138-68.894 0-95.174l-331.315-333.108 331.315-333.108c26.138-26.28 26.161-68.871 0-95.174s-68.523-26.28-94.661 0v0z" />
);
const ArrowRight = () => (
  <path d="M748.989 464.413c25.393 25.53 25.489 69.547 0 95.174l-378.646 380.695c-26.138 26.28-68.5 26.303-94.661 0s-26.138-68.894 0-95.174l331.315-333.108-331.315-333.108c-26.138-26.28-26.161-68.871 0-95.174s68.523-26.28 94.661 0l378.646 380.695z" />
);

export const ArrowIcon = ({
  direction = 'left',
  height = 16,
  width = 16,
  ...props
}: React.SVGProps<SVGSVGElement>) => (
  <svg
    data-testid={`icon-shape-arrow-${direction}`}
    fill="currentColor"
    height={height}
    role="presentation"
    viewBox="0 0 1024 1024"
    width={width}
    {...props}
  >
    {direction === 'left' ? <ArrowLeft /> : <ArrowRight />}
  </svg>
);
